import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';

const CloudUpload = ({ size, variant, className }: IconProps) => (
  <svg
    className={cn(iconVariant({ variant, size, className }))}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 50 50"
    fill="none">
    <path
      d="M16.6667 35.4167C10.9137 35.4167 6.25 30.753 6.25 25C6.25 19.899 9.9165 15.6544 14.7578 14.7578C15.6544 9.9165 19.899 6.25 25 6.25C30.101 6.25 34.3456 9.9165 35.2422 14.7578C40.0835 15.6544 43.75 19.899 43.75 25C43.75 30.753 39.0863 35.4167 33.3333 35.4167M18.75 25L25 18.75M25 18.75L31.25 25M25 18.75V43.75"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CloudUpload;
